import { render, staticRenderFns } from "./appBarDebugArea.vue?vue&type=template&id=fb3743e8&scoped=true"
import script from "./appBarDebugArea.vue?vue&type=script&lang=ts"
export * from "./appBarDebugArea.vue?vue&type=script&lang=ts"
import style0 from "./appBarDebugArea.vue?vue&type=style&index=0&id=fb3743e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3743e8",
  null
  
)

export default component.exports